import { render, staticRenderFns } from "./RigheDistintaComunicazioneConsumi.vue?vue&type=template&id=c3aa7ce8&scoped=true"
import script from "./RigheDistintaComunicazioneConsumi.vue?vue&type=script&lang=ts"
export * from "./RigheDistintaComunicazioneConsumi.vue?vue&type=script&lang=ts"
import style0 from "./RigheDistintaComunicazioneConsumi.vue?vue&type=style&index=0&id=c3aa7ce8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3aa7ce8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3aa7ce8')) {
      api.createRecord('c3aa7ce8', component.options)
    } else {
      api.reload('c3aa7ce8', component.options)
    }
    module.hot.accept("./RigheDistintaComunicazioneConsumi.vue?vue&type=template&id=c3aa7ce8&scoped=true", function () {
      api.rerender('c3aa7ce8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/consumi/RigheDistintaComunicazioneConsumi.vue"
export default component.exports